import { useContext } from "react";
import { AppContext } from "../App";
import { carePillars, hospitalInfo } from "../content/hospitalContent";
import { HiOutlineArrowNarrowRight } from "react-icons/hi";
import { FiShield, FiUsers, FiWind, FiPlus, FiGlobe, FiCpu, FiBarChart2, FiCheck, FiTarget, FiEye, FiLayers } from "react-icons/fi"; 
import banner1 from "../assets/banner2.jpg";
import banner2 from "../assets/banner1.jpg";
import { IoMdArrowForward } from "react-icons/io";

export default function HomeBanner3() {
  const appContext = useContext(AppContext);

  const getIcon = (title) => {
    const t = title.toLowerCase();
    if (t.includes("safety")) return <FiShield />;
    if (t.includes("team")) return <FiUsers />;
    if (t.includes("calm") || t.includes("comfort")) return <FiWind />;
    return <FiPlus />;
  };

  return (
    <>
      <style>{`
        :root {
          --clinical-teal: #0d9488;
          --deep-navy: #0f172a;
          --soft-slate: #64748b;
          --bg-clean: #ffffff;
          --slate-50: #f8fafc;
          --slate-100: #f1f5f9;
          --slate-200: #e2e8f0;
          --font-main: 'Inter', system-ui, -apple-system, sans-serif;
        }

        .care-section {
          font-family: var(--font-main);
          background-color: var(--bg-clean);
          padding: 140px 0;
          color: var(--deep-navy);
          position: relative;
        }

        .care-section::before {
          content: '+';
          position: absolute;
          font-size: 20rem;
          font-weight: 900;
          color: #f1f5f9;
          top: -50px;
          right: -50px;
          line-height: 1;
          pointer-events: none;
          z-index: 0;
        }

        .care-container {
          max-width: 1300px;
          margin: 0 auto;
          padding: 0 40px;
          position: relative;
          z-index: 1;
        }

        .care-header { margin-bottom: 80px; }

        .care-label {
          display: flex;
          align-items: center;
          gap: 12px;
          font-weight: 700;
          text-transform: uppercase;
          letter-spacing: 0.2em;
          font-size: 0.75rem;
          color: var(--clinical-teal);
          margin-bottom: 24px;
        }

        .care-label::after {
          content: "";
          height: 1px;
          width: 60px;
          background: var(--clinical-teal);
        }

        .care-title {
          font-size: clamp(2.8rem, 6vw, 4.5rem);
          font-weight: 800;
          line-height: 1;
          letter-spacing: -0.05em;
          margin: 0;
        }

        .care-title span { color: var(--soft-slate); font-weight: 300; }

        .care-grid {
          display: grid;
          grid-template-columns: repeat(12, 1fr);
          gap: 60px;
          align-items: flex-start;
        }

        .care-pillars-list {
          grid-column: 1 / 6;
          display: flex;
          flex-direction: column;
          gap: 48px;
        }

        .pillar-item { position: relative; padding-left: 56px; }

        .pillar-icon-wrapper {
          position: absolute;
          left: 0;
          top: 0;
          width: 40px;
          height: 40px;
          background: var(--deep-navy);
          color: white;
          border-radius: 4px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 1.2rem;
          box-shadow: 0 10px 20px rgba(15, 23, 42, 0.1);
        }

        .pillar-title {
          font-size: 1.1rem;
          font-weight: 700;
          margin: 0 0 8px 0;
          text-transform: uppercase;
          letter-spacing: 0.05em;
        }

        .pillar-desc { color: var(--soft-slate); line-height: 1.6; margin: 0; font-size: 0.95rem; }

        .care-visuals { grid-column: 7 / 13; position: relative; padding-top: 40px; }

        .img-frame { position: relative; overflow: hidden; border-radius: 8px; }

        .img-frame::after {
          content: "";
          position: absolute;
          inset: 0;
          background: linear-gradient(to top, var(--deep-navy), transparent);
          opacity: 0.4;
        }

        .img-main { width: 90%; height: 500px; object-fit: cover; display: block; }

        .img-sub-frame {
          position: absolute;
          bottom: -40px;
          right: 0;
          width: 60%;
          height: 300px;
          border: 15px solid var(--bg-clean);
          border-radius: 8px;
          overflow: hidden;
          box-shadow: 0 30px 60px rgba(0,0,0,0.15);
        }

        .img-sub { width: 100%; height: 100%; object-fit: cover; }

        .btn-modern {
          padding: 18px 36px;
          background: var(--deep-navy);
          color: white;
          font-weight: 700;
          text-transform: uppercase;
          font-size: 0.8rem;
          letter-spacing: 0.1em;
          border: none;
          cursor: pointer;
          transition: 0.4s cubic-bezier(0.16, 1, 0.3, 1);
          display: inline-flex;
          align-items: center; gap: 12px;
        }

        .btn-modern:hover { background: var(--clinical-teal); padding-right: 48px; }

        .strat-section {
          background: var(--slate-50);
          font-family: var(--font-main);
        }

        .strat-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 30px;
          margin-top: 60px;
        }

        .strat-grid-4 {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 30px;
          margin-top: 60px;
        }

        .strat-card {
          background: #ffffff;
          padding: 40px;
          border-radius: 12px;
          border: 1px solid var(--slate-200);
          transition: all 0.4s ease;
          display: flex;
          flex-direction: column;
        }

        .strat-card:hover { transform: translateY(-10px); box-shadow: 0 20px 40px rgba(0,0,0,0.05); border-color: var(--clinical-teal); }

        .horizon-tag {
          font-size: 0.7rem;
          font-weight: 800;
          color: var(--clinical-teal);
          text-transform: uppercase;
          letter-spacing: 0.1em;
          margin-bottom: 12px;
          display: block;
        }

        .strat-icon-box {
          font-size: 2rem;
          color: var(--deep-navy);
          margin-bottom: 20px;
        }

        .price-card {
          background: #ffffff;
          padding: 35px 30px;
          border-radius: 12px;
          border: 1px solid var(--slate-200);
          text-align: center;
          transition: all 0.4s ease;
        }

        .price-card:hover {
          transform: translateY(-5px);
          border-color: var(--clinical-teal);
          box-shadow: 0 15px 30px rgba(13, 148, 136, 0.08);
        }

        .price-val { font-size: 1.8rem; font-weight: 800; color: var(--deep-navy); margin: 5px 0; }
        .price-sub { font-size: 0.75rem; color: var(--soft-slate); margin: 0 0 20px 0; font-weight: 500; }
        .price-feat { font-size: 0.85rem; color: var(--soft-slate); list-style: none; padding: 0; margin: 20px 0; text-align: left; }
        .price-feat li { margin-bottom: 12px; display: flex; align-items: flex-start; gap: 10px; line-height: 1.4; }

        @media (max-width: 1024px) {
          .care-grid, .strat-grid, .strat-grid-4 { grid-template-columns: 1fr; }
          .care-pillars-list, .care-visuals { grid-column: 1 / -1; }
          .img-main { width: 100%; height: 350px; }
          .img-sub-frame { width: 50%; height: 200px; }
        }
      `}</style>

      <section className="strat-section pt-1 pb-5">
        <div className="care-container">
          <header className="care-header" style={{ textAlign: "center", margin: "75px 0 40px" }}>
            <h2 className="care-title" style={{ fontSize: "2.5rem" }}>Nanguba <span>Care Programme.</span></h2>
          </header>

          <div className="strat-grid">
            
            {/* Bronze Tier */}
            <div className="price-card">
              <span className="horizon-tag">Bronze <br/><span style={{ color: "var(--soft-slate)", fontSize: "0.65rem", fontWeight: "600" }}>Essential</span></span>
              <div className="price-val">TZS 30,000<small style={{ fontSize: "0.8rem", fontWeight: "400" }}>/mo</small></div>
              <hr style={{ border: "0", borderTop: "1px solid var(--slate-200)", margin: "20px 0" }}/>
              <ul className="price-feat">
                <li><FiCheck color="var(--clinical-teal)" style={{ marginTop: "2px", flexShrink: 0 }}/> 2 OPD Consultations per month</li>
                <li><FiCheck color="var(--clinical-teal)" style={{ marginTop: "2px", flexShrink: 0 }}/> 10% Pharmacy, Lab & Radiology Discounts</li>
                <li><FiCheck color="var(--clinical-teal)" style={{ marginTop: "2px", flexShrink: 0 }}/> Basic Annual Health Screening</li>
                <li><FiCheck color="var(--clinical-teal)" style={{ marginTop: "2px", flexShrink: 0 }}/> Covers up to 4 dependants</li>
              </ul>
            </div>

            {/* Silver Tier */}
            <div className="price-card" style={{ borderColor: "var(--clinical-teal)", boxShadow: "0 10px 30px rgba(13,148,136,0.1)" }}>
              <span className="horizon-tag">Silver <br/><span style={{ color: "var(--soft-slate)", fontSize: "0.65rem", fontWeight: "600" }}>Comprehensive</span></span>
              <div className="price-val">TZS 65,000<small style={{ fontSize: "0.8rem", fontWeight: "400" }}>/mo</small></div>
              <hr style={{ border: "0", borderTop: "1px solid var(--slate-200)", margin: "20px 0" }}/>
              <ul className="price-feat">
                <li><FiCheck color="var(--clinical-teal)" style={{ marginTop: "2px", flexShrink: 0 }}/> 4 OPD Consultations & 4 Lab Tests Included</li>
                <li><FiCheck color="var(--clinical-teal)" style={{ marginTop: "2px", flexShrink: 0 }}/> 20% Discount on Prescriptions & Extra Tests</li>
                <li><FiCheck color="var(--clinical-teal)" style={{ marginTop: "2px", flexShrink: 0 }}/> Priority booking (24-hour advance)</li>
                <li><FiCheck color="var(--clinical-teal)" style={{ marginTop: "2px", flexShrink: 0 }}/> Comprehensive Annual Health Screening</li>
              </ul>
            </div>

            {/* Gold Tier */}
            <div className="price-card">
              <span className="horizon-tag" style={{ color: "#ca8a04" }}>Gold <br/><span style={{ color: "var(--soft-slate)", fontSize: "0.65rem", fontWeight: "600" }}>Premium</span></span>
              <div className="price-val">TZS 130,000<small style={{ fontSize: "0.8rem", fontWeight: "400" }}>/mo</small></div>
              <hr style={{ border: "0", borderTop: "1px solid var(--slate-200)", margin: "20px 0" }}/>
              <ul className="price-feat">
                <li><FiCheck color="#ca8a04" style={{ marginTop: "2px", flexShrink: 0 }}/> Unlimited OPD Consultations</li>
                <li><FiCheck color="#ca8a04" style={{ marginTop: "2px", flexShrink: 0 }}/> 8 Labs & 1 Radiology Study Included</li>
                <li><FiCheck color="#ca8a04" style={{ marginTop: "2px", flexShrink: 0 }}/> Same-day appointments & Specialist Referrals</li>
                <li><FiCheck color="#ca8a04" style={{ marginTop: "2px", flexShrink: 0 }}/> Executive Health Screening & Monthly Wellness</li>
              </ul>
            </div>
            
          </div>
        </div>
        <div className="mt-5 text-center" style={{ marginTop: "60px" }}>
          <button className="btn btn-primary" onClick={()=>appContext.navTo({item:'contact_us'})}>
            Start Your Health Plan <IoMdArrowForward size={20} />
          </button>
        </div>
      </section>
    </>
  );
}